import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { crashed: false };
  }

  static getDerivedStateFromError() {
    return { crashed: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary capturó un error:', error, info);
  }

  render() {
    if (this.state.crashed) {
      return (
        <div className="min-h-screen bg-slate-900 flex items-center justify-center text-white px-6">
          <div className="text-center max-w-sm">
            <p className="text-5xl mb-4">😔</p>
            <h1 className="text-2xl font-black mb-2">Algo salió mal</h1>
            <p className="text-slate-400 text-sm mb-6">
              Ocurrió un error inesperado. Por favor recarga la página.
              Si el problema continúa, contáctanos al <strong className="text-white">954 167 7156</strong>.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-xl transition active:scale-95"
            >
              Recargar página
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
